import { Pipe, PipeTransform } from '@angular/core';
import { QUOTE_STATUSES, QuoteStatus } from '@lockton-apps/shared/interfaces';
import { QuoteStatusMetaPipe } from './quote-status.pipe';

interface QuoteStatusMeta {
  next: QuoteStatus | null;
  upcoming: QuoteStatus[];
}

@Pipe({
  name: 'renewalStatusQueue',
  standalone: true,
})
export class RenewalStatusQueue
  extends QuoteStatusMetaPipe<QuoteStatusMeta>
  implements PipeTransform
{
  // TODO:: "upcoming" statuses are currently on hold - Ellie needs to double check that across other partners, but I'm keeping it here, ready to add once confirmed
  map = new Map<QuoteStatus, QuoteStatusMeta>([
    [
      QUOTE_STATUSES.FormInitialized,
      { next: QUOTE_STATUSES.FormSent, upcoming: [] },
    ],
    [
      QUOTE_STATUSES.Quoted,
      { next: QUOTE_STATUSES.BrokerApproved, upcoming: [] },
    ],
    [
      QUOTE_STATUSES.BrokerApproved,
      { next: QUOTE_STATUSES.QuoteAccepted, upcoming: [] },
    ],
    [
      QUOTE_STATUSES.QuoteAccepted,
      { next: QUOTE_STATUSES.AwaitingPayment, upcoming: [] },
    ],
    [
      QUOTE_STATUSES.AwaitingPayment,
      { next: QUOTE_STATUSES.Complete, upcoming: [] },
    ],
  ]);

  defaultValue = { next: null, upcoming: [] };
}
